import React, { useState, useEffect } from "react";
import { Button, Offcanvas, Form, Modal, OverlayTrigger, Tooltip, Table } from "react-bootstrap";
import {
  WallpaperOutlined,
  ShortText,
  Texture,
  ModeEditOutlined,
  ArtTrack,
  AddOutlined,
  DeleteForeverOutlined,
  ErrorOutline
} from "@mui/icons-material";
import useForm from "../../hooks/useForm";
import toast from "react-hot-toast";
import TinyMCE from "./tinyMCE";
import GaleriaPgiModal from "../../pages/pgi/GaleriaPgiModal";
import useHome from "../../hooks/useHome";
import useAudit from "../../hooks/useAudit";
import getBloqueInfo from "../../services/getBloqueInfo";

const BloqueTxtPgi = ({ editBloque, open, fromHome, showBloque, infoEdit }) => {
  const {
    handleVisibilityBloque,
    bloqueInfoEdit,
    setBloqueInfoEdit
  } = useHome();
  const { createAuditRequest } = useAudit();
  const [bloqueNav, setBloqueNav] = useState(false);
  const [showNew, setShowNew] = useState(true);
  const [showCreateBloqueTxt, setShowCreateBloqueTxt] = useState(false);
  const [bloques, setBloques] = useState([]);
  const handleCloseBloqueTxt = () => setShowCreateBloqueTxt(false);
  const handleShowBloqueTxt = () => {
    setShowCreateBloqueTxt(!showCreateBloqueTxt);
    setBloqueInfoEdit(null);
    setBloqueNav(true);
  };
  const handleShowBloqueInfoEdit = () => {
    setShowCreateBloqueTxt(!showCreateBloqueTxt);
    setBloqueNav(false);
  };
  const [modalFor, setModalFor] = useState(null);

  useEffect(() => {
    const getInfoBloque = async () => {
      try {
        const response = await getBloqueInfo();
        setBloques(response.data.allBloqueInfo);
      } catch (error) {
        toast.error('Error al obtener la informacion de los bloques')
      }
    }
    getInfoBloque();
  }, []);

  const { values, setValues, handleInputChange, reset } = useForm({
    title: "Bloque_info",
    title_content: "",
    content: "",
    seeMoreLink: "",
    alignment: "",
    image_desktop: [],
    image_tablet: [],
    state: false,
    deleted: false
  });

  const user = JSON.parse(localStorage.getItem("Usuario"))?.UserLogin?.name;

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    bloqueInfoEdit
    ? await createAuditRequest(
            {
              ...values,
              title: "Bloque_info",
              element: 4,
              creator: user,
              publish: true,
              visible: true
            },
            "EDIT"
            )
            : await createAuditRequest({
              ...values,
              title: "Bloque_info",
              deleted: false,
              element: 4,
              creator: user,
              publish: true
            });
      setShowGaleria(false);
      setBloqueInfoEdit(null);
      setShowNew(true);
      reset();
      setValues({});
    } catch (error) {
      toast.error("Error al actualizar el bloque de texto");
    }
  };
  
  const handleDelete = (id) => {
    const toastId = toast(
      <div className="flex-column">
        <div className="text-center error_icon">
          <ErrorOutline />
        </div>
        <div className="text-center my-2">¿Estas seguro de eliminar este banner publicitario?</div>
        <div className="d-flex justify-content-around">
          <Button
            className="w-40 button_error"
            variant="danger"
            onClick={() => handleConfirmDelete(id, "DELETE")}
            >
            Si
          </Button>
          <Button
            className="w-40 button_error"
            variant="secondary"
            onClick={() => toast.dismiss(toastId)}
            >
            No
          </Button>
        </div>
      </div>,
      {
        duration: 20000
      }
      );
    };
    
    const handleConfirmDelete = (id, action) => {
      const newDelete = bloques?.find((noticia) => noticia._id === id && noticia);
      createAuditRequest(
        {
          ...newDelete,
          element: 4,
          deleted: true,
          image_desktop: [],
          image_tablet: [],
          visible: [],
          creator: user
        },
        "DELETE"
        );
        
        toast.dismiss();
      };
      
      const [showGaleria, setShowGaleria] = useState(false);
      const handleCloseGaleria = () => setShowGaleria(false);
      const handleShowGaleria = () => setShowGaleria(true);
      
      const handleModalClick = (modalFor) => {
        setModalFor(modalFor);
        handleShowGaleria();
      };
      
      useEffect(() => {
        setShowNew(showBloque)
        setBloqueInfoEdit({...infoEdit})
        setValues({...infoEdit})
      }, [showBloque, infoEdit]);
      
  return (
    <>
      {editBloque || infoEdit ? (
        <OverlayTrigger key="2" placement="top" overlay={<Tooltip id="2">Editar</Tooltip>}>
          <Button className="buttons_pgi_2" onClick={handleShowBloqueInfoEdit}>
            <ModeEditOutlined />
          </Button>
        </OverlayTrigger>
      ) : (
        <>
          <a
            className="buttons_pgi_2"
            id="edit-bloque"
            variant="light"
            onClick={handleShowBloqueTxt}
            
          >
            <ArtTrack />   <span>Bloque Info</span>
          </a>
          {!open ? <div className="tooltips">Bloque Info</div> : ""}
        </>
      )}
      <Offcanvas
        show={showCreateBloqueTxt}
        onHide={handleCloseBloqueTxt}
        className="basePgi__pgi  pgi__sidebar-container"
        placement="end"
        scroll="true"
        enforceFocus
        backdrop={false}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>BLOQUES DE INFORMACIÓN </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <form id="formAddBloqueTxt" className="basePgi__vista-edit-gral">
            <header>
              <p className="basePgi__comments">
                {fromHome
                  ? "Seleccione los Bloques de información para incorporar en la sección"
                  : "Seleccione los Bloques de información para incorporar en las distintas secciones"}
              </p>
              {fromHome ? (
                ""
              ) : (
                <OverlayTrigger
                  key="2"
                  placement="top"
                  overlay={<Tooltip id="2">Nuevo Bloque Info</Tooltip>}
                >
                  <Button
                    className="btn-form-pgi"
                    variant="light"
                    onClick={() => {
                      setBloqueInfoEdit(null);
                      setShowNew(!showNew);
                      reset();
                    }}
                  >
                    <AddOutlined />
                  </Button>
                </OverlayTrigger>
              )}
            </header>
            <Table responsive className="basePgi__table-list" hover>
              <colgroup>
                {fromHome && <col span="1" className="basePgi__table-col-min" />}
                <col span="1" className="basePgi__table-col-max" />
                {!fromHome && <col span="2" className="basePgi__table-col-min" />}
              </colgroup>
              <tbody>
                {bloques?.map(
                  (bloque) =>
                    bloque?.deleted === false && (
                        <tr key={bloque._id}>
                          {fromHome && (
                            <td className="pgi__table-check">
                              <Form.Check
                                inline
                                aria-label="banner #id" // indicar x variable el nº id
                                name="selectBanner"
                                type="checkbox"
                                id="align-left"
                                defaultChecked={bloque?.visible?.find((item) => item === "home")}
                                onClick={() => {
                                  handleVisibilityBloque(bloque._id, "home");
                                }}
                              />
                            </td>
                          )}
                          <td>{bloque.title_content}</td>
                          {bloqueNav && !fromHome && (
                            <>
                              <td
                                onClick={() => {
                                  setShowNew(true);
                                  setBloqueInfoEdit({ ...bloque });
                                  setValues({ ...bloque });
                                  setTimeout(() => {
                                    setShowNew(false);
                                  }, 500);
                                }}
                              >
                                <OverlayTrigger
                                  key="2"
                                  placement="top"
                                  overlay={<Tooltip id="2">Editar</Tooltip>}
                                >
                                  <Button>
                                    <ModeEditOutlined />
                                  </Button>
                                </OverlayTrigger>
                              </td>
                              <td onClick={() => handleDelete(bloque._id)}>
                                <OverlayTrigger
                                  key="2"
                                  placement="top"
                                  overlay={<Tooltip id="2">Eliminar</Tooltip>}
                                >
                                  <Button>
                                    <DeleteForeverOutlined />
                                  </Button>
                                </OverlayTrigger>
                              </td>
                            </>
                          )}
                        </tr>
                    )
                )}
              </tbody>
            </Table>
          </form>
          <hr className="basePgi__space-line" />
          {!showNew && (
            <form
              className={`basePgi__vista-edit-gral ${showNew ? "d-none" : "d-block"}`}
              id="bloque-txt"
              onSubmit={handleSubmit}
            >
              <header className="basePgi-header-border" aria-labelledby="formEditarHSlider">
                {bloqueInfoEdit ? <h2>Editar Bloque Info</h2> : <h2>Nuevo Bloque Info</h2>}
              </header>
              <fieldset className="pgi__sidebar-container-items form-group">
                <div className="form-floating">
                  <input
                    type="text"
                    className="form-control"
                    name="title_content"
                    id="title"
                    placeholder="..."
                    value={values.title_content}
                    onChange={handleInputChange}
                    maxLength={80}
                    minLength={2}
                  />
                  <label htmlFor="title">Título</label>
                </div>

                <div className="form-floating">
                  <div className="pgi__container-img" style={{ display: "none" }}>
                  </div>
                  <div className="form-floating">
                    <TinyMCE
                      values={values.content}
                      handleInputChange={handleInputChange}
                      name={"content"}
                    />
                    <label htmlFor="content">Texto</label>
                  </div>
                  <div className="form-floating">
                    <div className="pgi__container-img" style={{ display: "none" }}>
                    </div>
                    <div className="form-floating mb-4">
                      <input
                        type="text"
                        className="form-control"
                        name="seeMoreLink"
                        id="seeMoreLink"
                        placeholder="..."
                        value={values.seeMoreLink}
                        onChange={handleInputChange}
                      />
                      <label htmlFor="seeMoreLink">Enlace</label>
                      <p className="basePgi__comments">
                        <span>Ejemplo: /donde-comprar</span>
                      </p>
                      <p className="basePgi__comments">
                        <span>
                          Ejemplo: https://www.youtube.com/channel/UCs2eaZaC-7SNPcrbm1o2LDA
                        </span>
                      </p>
                    </div>

                    <Modal
                      id="galleryModal"
                      className="modalContenedor__galeria"
                      show={showGaleria}
                      onHide={handleCloseGaleria}
                    >
                      <Modal.Header closeButton></Modal.Header>
                      <Modal.Body>
                        <GaleriaPgiModal
                          editProduct={values}
                          setEditProduct={setValues}
                          modalFor={modalFor}
                          handleCloseGaleria={handleCloseGaleria}
                        />
                      </Modal.Body>
                    </Modal>
                    <Button
                      className="btn-form-pgi pgi__head-modules"
                      onClick={() => handleModalClick("image_desktop")}
                    >
                      Seleccionar imagen desktop
                      <WallpaperOutlined />
                    </Button>
                    <p className="basePgi__comments">Ejemplo: https://tensolite.com/</p>
                  </div>
                  <Modal
                    id="galleryModal"
                    className="modalContenedor__galeria"
                    show={showGaleria}
                    onHide={handleCloseGaleria}
                  >
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                      <GaleriaPgiModal
                        editProduct={values}
                        setEditProduct={setValues}
                        modalFor={modalFor}
                        handleCloseGaleria={handleCloseGaleria}
                      />
                    </Modal.Body>
                  </Modal>
                  <Button
                    className="btn-form-pgi pgi__head-modules"
                    onClick={() => handleModalClick("image_desktop")}
                  >
                    Seleccionar imagen desktop
                    <WallpaperOutlined />
                  </Button>
                  <p className="basePgi__comments">
                    <span>Imagen para Escritorio (.jpg, .png). Proporción 16:9</span>
                  </p>
                </div>
                <hr />
                <div className="pgi__select-align-text">
                  <p>Alineación de imagen</p>
                  <Form.Check
                    inline
                    label={
                      <div>
                        <Texture />
                        <ShortText />
                      </div>
                    }
                    checked={values.alignment === "align-left"}
                    name="alignment"
                    type="radio"
                    id="align-left"
                    value="align-left"
                    onChange={handleInputChange}
                  />
                  <Form.Check
                    inline
                    label={
                      <div>
                        <ShortText />
                        <Texture />
                      </div>
                    }
                    checked={values.alignment === "align-right"}
                    name="alignment"
                    type="radio"
                    id="align-right"
                    value="align-right"
                    onChange={handleInputChange}
                  />
                </div>
                <hr />

                <button type="submit" className="settings_button-pleno">
                  GUARDAR
                </button>
              </fieldset>
            </form>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default BloqueTxtPgi;
